import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: 'EmpresaCentro/getConsentimiento', method: 'GET', body: null})
}
